import { Link } from "react-router-dom/cjs/react-router-dom";
import React from "react";
const FavouriteCourse = (args) => {
    const lastCourse=args.lastCourse

    return(
      <div className="card">
          <div className="card-body">
              <div className="custom-tab-1 latest-recruitment">
                  <strong className='upcome'>Favourite Course</strong>
                  <Link to="" className="more-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heart-fill text-danger" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314" />
                      </svg></Link>
                  <div className="tab-content">
                      <div id="in-progress" className="tab-pane active">
                          <Link to="CourseDetail"> <div className="courselist">
                              <div className="mycourselist">
                                  <div className="imgdiv">
                                      <img className="avatar is-squared w-100" src="images/org-img/learn/2.jpg" />
                                      <span className="course-time"><img src="images/org-img/recruitment/time.svg" />2h 30m</span>
                                  </div>
                                  <div className="course-card">
                                      <span className="leveltag">{lastCourse?.Name}</span>
                                      <h3 className="dark-inverted">{lastCourse?.CourseTitle}</h3>
                                      <p>Web Development</p>
                                      <div className="students pb-0">
                                          <div className="h-avatar is-small">
                                              <img className="avatar" src="images/avatar/6.jpg" alt="" />
                                          </div>
                                          <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                      </div>
                                      <div className="attached-block">
                                          <ul>
                                              <li>66 Articles</li>
                                              <li>6 Exercies</li>
                                              <li>{lastCourse?.Quiz} Quizz</li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div></Link>
                          <Link to="CourseDetail"> <div className="courselist">
                              <div className="mycourselist">
                                  <div className="imgdiv">
                                      <img className="avatar is-squared w-100" src="images/org-img/learn/6.jpg" />
                                      <span className="course-time"><img src="images/org-img/recruitment/time.svg" />2h 30m</span>
                                  </div>
                                  <div className="course-card">
                                      <span className="leveltag">Intermediate</span>
                                      <h3 className="dark-inverted">Angular Testing: Unit Testing Angular and E2E Testing</h3>
                                      <p>Web Development</p>
                                      <div className="students pb-0">
                                          <div className="h-avatar is-small">
                                              <img className="avatar" src="images/avatar/6.jpg" alt="" />
                                          </div>
                                          <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                      </div>
                                      <div className="attached-block">
                                          <ul>
                                              <li>66 Articles</li>
                                              <li>6 Exercies</li>
                                              <li>{lastCourse?.Quiz} Quizz</li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );


  }

  export default FavouriteCourse;
